import { Product } from '@/modules/products/types';
import { axios } from '@/utils';

export const getProductsService = async () => (await axios.get('/products/branch')).data.data;

export const getProductsResumeService = async () => (await axios.get('/products/branch')).data;

export const saveProductService = async (body: Product) =>
  (await axios.post('/products', body)).data.data;

export const editProductService = (id: number) => async (body: Product) =>
  (await axios.put(`/products/${id}`, body)).data.data;

export const getOneProduct = async (id: number) => (await axios.get(`/products/${id}`)).data.data;
export const changeStatusProduct = async (id: number) =>
  (await axios.put(`/products/status/${id}`)).data.data;

export const calculateAllPriceProducts = async () =>
  (await axios.put('/products/calculate-all')).data.data;
